export enum DelarStatus {
  Rejected = -1,
  NotInit = 0,
  Pending = 1,
  Verified = 2,
  DELER_DATA_FIELD_REJECTED = -1,
  DELER_DATA_FIELD_NOT_INIT = 0,
  DELER_DATA_FIELD_PENDING = 1,
  DELER_DATA_FIELD_VERIFIED = 2
}